export function findDays(dayOne, dayTwo) {

	let dateOne = new Date(dayOne)
	let dateTwo = new Date(dayTwo)

	let diffTime = (dateTwo.getTime() + (3 * 60 * 60 * 1000)) - dateOne.getTime();

	let diffDays = diffTime / ((1000 * 60 * 60 * 24));

	return diffDays.toFixed();
}